<template>
  
    <div ref="sessionCardRef">
        
        <div class="myCenter">

            <div class="w-full">
                
                <card-details-component :mySlot="mySlot" :key="dayDate" :isOnline="true"
                :email="email" :myReload="myReload" :isCard="false" :displayModal="displayModal"
                 :index="index" :dayDate="dayDate"
                :showClassPage="showClassPage" :classType="classType" :myClass="myClass"
                :disableButton="disableButton"/>
            </div>            
        </div>
    </div>

</template>

<script>

import { RingLoader } from 'vue-spinners-css';

import moment from 'moment';


import componentsHelpers from '../../classes/componentHelpers';

import cardImagesComponent from '../../components-v2/cards-components/CardImages.vue'
import cardDetailsComponent from './SessionClassPageCardDetails.vue'

export default {

    created(){

    },

    mounted(){
        
        // console.log(`myClass: ${JSON.stringify(this.myClass)}`);

        // this.setIsBooked(this.dayDate);
    },

    props: {

        myClass:{

            type: Object
        },

        classType: '',

        email: '',

        index: 0,

        classType: '',

        showClassPage: {

            type: Function
        },

         openOneSlotMapModal: {

            type: Function
        },

        disablePage: false,

        disableButton: false,

        isOnline: false,

        dayDate: '',

        mySlot:{

            type: Object
        },

        businessInfo:{
      
            type: Object,
        },

        instructors:{

            type: Array 
        },

        myReload: {

            type: Function
        },

        displayModal: {

            type: Function
        },
    },

    components:{

        RingLoader,
        cardImagesComponent,
        cardDetailsComponent
    },

    methods:{

        // callShowDescription(){

        //     // console.log(`in callShowDescription`);

        //     // console.log(`here ${JSON.stringify(this.mySlot)}`);
        //     this.showDescription(this.mySlot);
        // },

    },

    data: function(){

    return{

        loading:false,  
        booked: false,
        myDayDate: this.dayDate,
        cardImages:[],
        modalImages: [],
        booked: false,
    }
    },

}
</script>

<style>

</style>